import React, { lazy } from "react";
import { Route, Routes, useLocation, useParams, Navigate } from 'react-router';
import { Container, Loader } from 'semantic-ui-react'
import user_model from 'models/user_model'
import cat_model from 'models/cat_model'
// import {CONDITIONS_PAGES_MAPPING, SPECIFIC_CONDITION_REDIRECTS} from './constants'
import withData from 'xAppLib/HOC/withData'
import withAccess from 'xAppLib/HOC/withAccess'
import NotFound from "views/content/NotFound";

import withSuspense from "xAppLib/libs/withSuspense";


const AdminRemindersList = withSuspense(lazy(() => import('views/reminders/AdminRemindersList')))
// Route name is fixed - the booth pairing backend builds this URL into the QR code shown on the booth screen.
const ImInABooth = withSuspense(lazy(_=>import('views/booth/patient/ImInABooth')))
const PostBoothOrder = withSuspense(lazy(_=>import('views/booth/patient/screens/PostOrder')))

function withCatRoute(WrappedComponent) {
	return function({...rest}) {
		const params = useParams()
		const location = useLocation()
		if (params['*']) {
			params['*'] = params['*'].replace(/\/$/,'')
			if (location.pathname.startsWith(app.consts.routes.cat_route) || location.pathname.startsWith('/admin'+app.consts.routes.cat_route))
				params.cat_route = params['*']
			else if (location.pathname.startsWith(app.consts.routes.med_route) || location.pathname.startsWith('/admin'+app.consts.routes.med_route)) {
				const parts = params['*'].split('/')
				params.med_code = parts.pop()
				params.cat_route = parts.join('/')
			}
			else if (location.pathname.startsWith('/remed/')) {
				const parts = params['*'].split('/');
				params.sid = parts.pop();
				params.med_code = parts.pop();
				params.cat_route = parts.join('/');
			}
		} else {
			for (const name of ['cat_route', 'med_code', 'sid']) {
				if (name in rest) {
					params[name] = rest[name];
				}
			}
		}

		const props = { match: { params }, ...rest }
		return <WrappedComponent match={{params}} { ...props } />
	}

}

import { cat_nms } from 'models/cat_model';

// Core Pages
// import Cat from 'xAppLib/Cat/Cat'
import CatExp from 'xAppLib/Cat/Cat'
import Med from 'views/med/MedNew'

const CatWaccess = withCatRoute(withAccess(CatExp, CatExp.access))
// const MedWaccess = app.runtime?.login_type=='popup' ? Med : withAccess(Med, Med.access);
const MedWaccess = withCatRoute(withAccess(Med, Med.access));

let CatsWdata_arr = {};
let MedsWdata_arr = {};
cat_nms.map(cat_nm=> CatsWdata_arr[cat_nm] = withData(CatWaccess, _=>cat_model.get_cat_list({cat_nm})) )
cat_nms.map(cat_nm=> MedsWdata_arr[cat_nm] = withData(MedWaccess, _=>cat_model.get_cat_list({cat_nm})) )
const MedsWdataPharm = MedsWdata_arr['pharm'];


import HomepageWrapper from 'views/pages/homepage/HomepageWrapper'
import Login from 'xAppLib/Users/Login'
import About from 'views/pages/About'
import Pricing from "./views/pages/Pricing";
import UserProfile from 'xAppLib/Users/UserProfile'
import Password from 'xAppLib/Users/Password'
import OnePass from "./views/pages/OnePass"
import { withSentryReactRouterV6Routing } from '@sentry/react'
import Refer from "./views/pages/Refer";
import LoginPage from 'views/pages/LoginPage'
import SignUpPage from 'views/pages/SignUpPage'
import BlogWrapper from "./contentful/pages/blog/BlogWrapper"

import NotificationsPage from "./notifications/view/NotificationsPage";
const AdminNotificationsPage = withSuspense(lazy(_=>import('./notifications/view/AdminNotificationsPage')))


// InstantCosmetics
import ICosmHomepage from 'views/icosm/Homepage'
import ICosmContact from 'views/icosm/Contact'
import ICosmNurse from "./views/icosm/Nurse";
import ICosmGrow from "./views/icosm/Grow";
import ICosmValues from "./views/icosm/Values";
import ICosmFaq from "./views/icosm/IcosmFaq";
import ICosmOversight from "./views/icosm/Oversight";
import ICosmSoftware from "./views/icosm/Software";
import ICosmComplicance from "./views/icosm/Compliance";
import ICosmSupport from "./views/icosm/Support";
import ICosmTraining from "./views/icosm/Training";
import ICosmJoin from "./views/icosm/GetStarted";
import ICosmClinicalAdvisoryCommittee from "./views/icosm/ClinicalAdvisoryCommittee";
import PreviewPatientForms from "@iscr/views/icosm/treatment/PreviewPatientForms";
const IcosmLoggedInHome = withSuspense(lazy(_=> import("./views/icosm/LoggedInHomepage")));
const Complications = withSuspense(lazy(_=>import('./views/icosm/complications/Complications')))
// const ICosmLearningVideos = withSuspense(lazy(_=>import('views/icosm/learning/LearningVideos')))	

// const Training = withSuspense(lazy(_=>import('views/icosm/Training')))
const CreateTreatmentForm = withSuspense(lazy(_=>import('views/icosm/treatment/CreateTreatmentForm')))
const RevisitTreatmentFormLoader = withSuspense(lazy(_=>import('views/icosm/treatment/RevisitTreatmentForm')))
const OrderProductForm = withSuspense(lazy(_=>import('views/icosm/treatment/components/OrderProductForm')))
const AdministerScheduledProductOrderForm = withSuspense(lazy(_=>import('views/icosm/treatment/components/AdministerScheduledProductOrderForm')))
const RevisitProductOrderForm = withSuspense(lazy(_=>import('views/icosm/treatment/components/RevisitProductOrderForm')))
const ListTreatmentPlans = withSuspense(lazy(_=>import('views/icosm/treatment/ListTreatmentPlans')))
const ViewTreatmentPlan = withSuspense(lazy(_=>import('views/icosm/treatment/ViewTreatmentPlan')))
const CosmeticTreatmentPlanDoctorConsult = withSuspense(lazy(_=>import('views/icosm/treatment/DoctorConsult')))
const FulfillInvoice = withSuspense(lazy(_=>import('views/icosm/FulfillInvoice')))
const TwiloTestBed = withSuspense(lazy(_=>import('views/UIelems/TwilioConference/TestBed')))

// Instant PrEP
import IPrepHomepage from 'views/iprep/Homepage'
const IPrepContent = withSuspense(lazy(_=>import('views/iprep/Content')))
const IPrepProgress = withSuspense(lazy(_=>import('views/iprep/ApplicationProgress')))

// Instant The Green Doc
import ICannHomepage from 'views/icann/Homepage'
const ICannGetStarted = withSuspense(lazy(_=>import('views/icann/GetStartedPage')))
const ICannPatient = withSuspense(lazy(_=>import('views/icann/PatientPage')))
const ICannSupport = withSuspense(lazy(_=>import('views/icann/SupportPage')))
const ICannAboutUs = withSuspense(lazy(_=>import('views/icann/AboutUs')))
const ICannFaq = withSuspense(lazy(_=>import('views/icann/FAQ')))


// Project Blaze - Breathe Life Sciences
const BlsHomePage = withSuspense(lazy(_=>import('views/icann/cbls/HomePage')))
const BlsAboutUs = withSuspense(lazy(_=>import('views/icann/cbls/AboutUs')))
const BlsGetStarted = withSuspense(lazy(_=>import('views/icann/cbls/GetStartedPage')))
const BlsForPatients = withSuspense(lazy(_=>import('views/icann/cbls/PatientPage')))
const BlsSupport = withSuspense(lazy(_=>import('views/icann/cbls/SupportPage')))
// const BlsFaq = withSuspense(lazy(_=>import('views/icann/cbls/FAQ')))

// Project Blaze - Haiku Health
const MgHomePage = withSuspense(lazy(_=>import('views/icann/cmg/HomePage')))
const MgAboutUs = withSuspense(lazy(_=>import('views/icann/cmg/AboutUs')))
const MgGetStarted = withSuspense(lazy(_=>import('views/icann/cmg/GetStartedPage')))
const MgForPatients = withSuspense(lazy(_=>import('views/icann/cmg/PatientPage')))
const MgSupport = withSuspense(lazy(_=>import('views/icann/cmg/SupportPage')))
const MgFaq = withSuspense(lazy(_=>import('views/icann/cmg/FAQ')))
const MgIndications = withSuspense(lazy(_=>import('views/icann/cmg/Indications')))

// Instant Ileg
// import ILegHomepage from 'views/ileg/Homepage'
// const ILegPatient = withSuspense(lazy(_=>import('views/ileg/PatientPage')))
// const ILegLawyer = withSuspense(lazy(_=>import('views/ileg/LawyerPage')))
// const ILegRequest = withSuspense(lazy(_=>import('views/ileg/RequestPage')))

import SiteToggle from "./xAppLib/AB/SiteToggle";

// Dynamic bundles
const AdminCatX = withSuspense(lazy(_=>import('xAppLib/Cat/AdminCat')))
const AdminCat = withCatRoute(AdminCatX)

const AdminOrgs = withSuspense(lazy(_=>import('xAppLib/Orgs/AdminOrgs')))
// const AdminOrg = withSuspense(lazy(_=>import('xAppLib/Orgs/AdminOrg')))
const OrgSignUp = withSuspense(lazy(_=>import('xAppLib/Orgs/OrgSignUp')))
const DocSignUp = withSuspense(lazy(_=>import('views/doc/DocSignUp')))

const AdminMedX = (withSuspense(lazy(_=>import('views/admin/med/AdminMed'))))
const AdminMed = withCatRoute(AdminMedX)
const AdminMeds = withSuspense(lazy(_=>import('views/admin/med/AdminMeds')))
const AdminProds = withSuspense(lazy(_=>import('views/admin/prods/AdminProds')))
const AdminProd = withSuspense(lazy(_=>import('views/admin/prods/AdminProd')))
const AdminDocs = withSuspense(lazy(_=>import('views/admin/docs/AdminDocs')))
const AdminDoc = withSuspense(lazy(_=>import('views/admin/docs/AdminDoc')))
const AdminDocPayRules = withSuspense(lazy(_=>import('views/admin/docpay/rules/DocPay')))
const AdminDocPayProducts = withSuspense(lazy(_=>import('views/admin/docpay/products/DocPayProducts')))
const AdminDocPayDashboardPage = withSuspense(lazy(_=>import('views/admin/docpay/dashboard/DashboardPage')))
const AdminDocsRoster = withSuspense(lazy(_=>import('views/admin/docs/AdminDocsRoster')))
const AdminDocsSkypeCosts = withSuspense(lazy(_=>import('views/admin/docs/AdminDocsSkypeCosts')))
const AdminBatchExport = withSuspense(lazy(_=>import('views/admin/export/AdminBatchExport')))
const AdminSiteStatus = withSuspense(lazy(_=>import('xAppLib/SiteStatus/AdminSiteStatus')))
const AdminDocsAhpra = withSuspense(lazy(_=>import('views/admin/docs/AdminDocsAhpra')))
const AdminSiteRoutes = withSuspense(lazy(_=>import('views/admin/routes/AdminSiteRoutes')))

const EditRawData = withSuspense(lazy(_=>import('xAppLib/UIelems/EditRawData')))
const EditJsonModal = withSuspense(lazy(_=>import('xAppLib/UIelems/EditJsonModal')))

const AdminDevices = withSuspense(lazy(_=>import('views/admin/devices/AdminDevices')))
const AdminUsers = withSuspense(lazy(_=>import('@iscr/xAppLib/Users/AdminUsers/AdminUsers')))
const AdminIdpUsers = withSuspense(lazy(_=>import('@iscr/xAppLib/Users/AdminIdpUsers')))

const ScriptsList = withSuspense(lazy(_=>import('views/scripts/ScriptsList')))
const ViewScript = withSuspense(lazy(_=>import('views/scripts/ViewScript')))
const InstCons_WR_gp = withSuspense(lazy(_=>import('views/instcons/InstCons_WR_gp')))
const InstCons_WR_gp_stats = withSuspense(lazy(_=>import('views/instcons/InstCons_WR_gp_stats')))
const InstCons_WR_exprcons = withSuspense(lazy(_=>import('views/instcons/InstCons_WR_exprcons')))
const Authenticate = withSuspense(lazy(_=>import('views/Authenticate')))

const SeshsList = withSuspense(lazy(_=>import('xAppLib/Seshs/SeshsList')))

const TransList = withSuspense(lazy(_=>import('views/trans/TransList')))
const Stats = withSuspense(lazy(_=>import('views/scripts/Stats')))
const MainStats = withSuspense(lazy(_=>import('views/stats/MainStats')))

const MedicareStats = withSuspense(lazy(_=>import('views/medicare/Stats')))
const MedicareList = withSuspense(lazy(_=>import('views/medicare/MedicareList')))

const Patients = withSuspense(lazy(_=>import('views/patients/Patients')))
const Patient = withSuspense(lazy(_=>import('views/patients/Patient')))

const Prescs = withSuspense(lazy(_=>import('views/admin/prescs/Prescs')))
const Notes = withSuspense(lazy(_=>import('views/admin/notes/Notes')))
const Cron = withSuspense(lazy(_=>import('views/admin/cron/Cron')))

const MimsUserManagement = withSuspense(lazy(_=>import('mims/components/UserManagement')))
const MimsPrescribingRules = withSuspense(lazy(_=>import('mims/components/PrescribingRules')))
const DemoScriptPad = React.lazy(_=>import('mims/components/DemoScriptPad'));
const AdminFeedback = withSuspense(lazy(_=>import('views/admin/feedback/AdminFeedback')))
const AdminFeedbackTemplates = withSuspense(lazy(_=>import('views/admin/feedback/AdminFeedbackTemplates')))

const AdminCarees = React.lazy(_=>import('views/admin/carees/AdminCarees'))

const BookingAvailability = withSuspense(lazy(_=>import('views/booking/BookingAvailability')))
const AdminBookingAvailability = withSuspense(lazy(_=>import('views/booking/AdminBookingAvailability')))
const AdminBookingTimePeriods = withSuspense(lazy(_=>import('views/booking/AdminBookingTimePeriods')))
const AdminBookingUsers = withSuspense(lazy(_=>import('views/booking/AdminBookingUsers')))
const BookingAppointment = withSuspense(lazy(_=>import('views/booking/BookingAppointment')))
const BookingRoster = withSuspense(lazy(_=>import('views/booking/BookingRoster')))
const BookingAppointmentList = withSuspense(lazy(_=>import('views/booking/BookingAppointmentList')))
const AdminBookingAppointment = withSuspense(lazy(_=>import('views/booking/AdminBookingAppointment')))
const AdminAppointmentList = withSuspense(lazy(_=>import('views/booking/AdminAppointmentList')))
const AdminBookingRoster = withSuspense(lazy(_=>import('views/booking/AdminBookingRoster')))


const OrgAdminRosterUsers = withSuspense(lazy(_=>import('cosmetics/booking/view/roster/admin/OrgAdminRosterUsers')))
const OrgAdminRosterUser = withSuspense(lazy(_=>import('cosmetics/booking/view/roster/admin/OrgAdminRosterUser')))
const OrgAdminAppointmentList = withSuspense(lazy(_=>import('cosmetics/booking/view/appointment/admin/OrgAdminAppointmentList')))

const OrgStaffRoster = withSuspense(lazy(_=>import('cosmetics/booking/view/roster/staff/OrgStaffRoster')))
const OrgStaffAppointmentList = withSuspense(lazy(_=>import('cosmetics/booking/view/appointment/staff/OrgStaffAppointmentList')))
const OrgStaffBooking = withSuspense(lazy(_=>import('cosmetics/booking/view/appointment/staff/OrgStaffBooking')))

const Discounts = withSuspense(lazy(_=>import('views/admin/discounts/Discounts')))
const PulseRewardsAdmin = withSuspense(lazy(_=>import('views/admin/pulse-rewards/PulseRewardsAdmin')))
const PulseRewardsStats = withSuspense(lazy(_=>import('views/admin/pulse-rewards/PulseRewardsStats')))
const PricingShadowAdmin = withSuspense(lazy(_=>import('views/admin/pricing-shadow/PricingShadowAdmin')))
const PricelineStats = withSuspense(lazy(_=>import('views/admin/priceline-stats/PricelineStats')))
const EmployeeBenefitsAdmin = withSuspense(lazy(_=>import('views/admin/employee-benefits/EmployeeBenefitsAdmin')))
const EmployeeBenefitsStats = withSuspense(lazy(_=>import('views/admin/employee-benefits/EmployeeBenefitsStats')))
const AdminCardTransactions = withSuspense(lazy(_=>import('views/admin/card-transactions/AdminCardTransactions')))
const EvermedControlRoom = withSuspense(lazy(_=>import('views/admin/evermed-control-room/EvermedControlRoom')))

const KBAdmin = withSuspense(lazy(_=>import('xAppLib/KnowledgeBase/KBAdmin')))
const KB = withSuspense(lazy(_=>import('xAppLib/KnowledgeBase/KB')))
const KBDirectory = withSuspense(lazy(_=>import('xAppLib/KnowledgeBase/KBDirectory')))
const CosmTraining = withSuspense(lazy(_=>import('views/pages/CosmTraining')))
const CosmProducts = withSuspense(lazy(_=>import('views/pages/CosmProducts')))

const OnlineUsers = withSuspense(lazy(_=>import('xAppLib/Team/OnlineUsers')))
const OnlineDoctors = withSuspense(lazy(_=>import('views/Team/OnlineDoctors')))
const ChatHome = withSuspense(lazy(_=>import('xAppLib/Chat/ChatHome')))
const ChatChannel = withSuspense(lazy(_=>import('xAppLib/Chat/ChatChannel')))

const ManageTreatmentPlan = withSuspense(lazy(_=>import('views/treatment_plans/user/ManageTreatmentPlan')))
const MyTreatmentPlans = withSuspense(lazy(_=>import('views/treatment_plans/user/MyTreatmentPlans')))
const AdminListTreatmentPlans = withSuspense(lazy(_=>import('views/treatment_plans/admin/ListTreatmentPlans')))
const TreatmentLimitSmokeTest = withSuspense(lazy(_=>import('views/treatment_plans/admin/TreatmentLimitSmokeTest')))

const History = withSuspense(lazy(_=>import('views/pages/OrderHistory')))
const HistoryWithData = withData(History,cat_model.get_cat_list)

const OldHistory = withSuspense(lazy(_=>import('views/pages/OldHistory')))
const OldHistoryWithData = withData(OldHistory,cat_model.get_cat_list)

const ProdsSale = withSuspense(lazy(_=>import('views/prods/ProdsSale')))
const ProdsStats = withSuspense(lazy(_=>import('views/prods/ProdsStats')))
const Shop = withSuspense(lazy(_=>import('views/prods/Shop')))
const ManualScript = withSuspense(lazy(_=>import('views/admin/scripts/ManualScript')))
const Data_page = withSuspense(lazy(_=>import('views/pages/Data_page')))

const Feedback = withSuspense(lazy(_=>import('views/feedback/Feedback')))

const ExprCons = withSuspense(lazy(_=>import('views/doc/DocCons-exprcons')))
const DocConsEscript = withSuspense(lazy(_=>import('views/doc/DocCons-escript')))
import ProdsNavig from "./xAppLib/ProdsNavig/ProdsNavig";

const DocCons_pts = withSuspense(lazy(_=>import('views/doc/DocCons_pts')))
const MIMS = withSuspense(lazy(_=>import('views/doc/MIMS')))
const TG = withSuspense(lazy(_=>import('views/doc/TG')))
// const ResultsFollowup = withSuspense(lazy(_=>import('views/doc/ResultsFollowup')))
const ResultsFollowupAll = withSuspense(lazy(_=>import('views/doc/ResultsFollowupAll')))
const InstCons_WR = withSuspense(lazy(_=>import('views/instcons/InstCons_WR')))

const InstCons_cosm_doc = withSuspense(lazy(_=>import('views/instcons/InstCons_cosm_doc')))

const DocNoti = withSuspense(lazy(_=>import('views/doc/DocNoti')))

const DocCons_req = withSuspense(lazy(_=>import('views/doc/DocCons_req')))

const MB_prices = withSuspense(lazy(_=>import('views/medbuy/MB_prices')))
const GS_DB_sync = withSuspense(lazy(_=>import('views/data/GS_DB_sync')))

const Results = withSuspense(lazy(_=>import('views/results/Results')))
const DashboardResults = withSuspense(lazy(_=>import('views/results/DashboardResults')))
const Audit = withSuspense(lazy(_=>import('views/admin/audit/Audit')))
const AuditScripts = withSuspense(lazy(_=>import('views/admin/audit/AuditScripts')))
const AuditeScripts = withSuspense(lazy(_=>import('views/admin/audit/AuditeScripts')))
const AuditeDSPID = withSuspense(lazy(_=>import('views/admin/audit/AuditeDSPID')))
const AuditeOrphanIHI = withSuspense(lazy(_=>import('views/admin/audit/AuditOrphanIHI')))
const AuditHIServiceIHI = withSuspense(lazy(_=>import('views/admin/audit/AuditHIServiceIHI')))
const AuditHIServiceError = withSuspense(lazy(_=>import('views/admin/audit/AuditHIServiceError')))
const AuditHIBatch = withSuspense(lazy(_=>import('views/admin/audit/AuditHIBatch')))
const DuplicateUsers = withSuspense(lazy(_=>import('views/admin/audit/DuplicateUsers')))
const AuditHIOperatorAlerts = withSuspense(lazy(_=>import('views/admin/audit/AuditHIOperatorAlerts')))
const VidCallTroubleshooting = withSuspense(lazy(_=>import('views/supp/VidCallTroubleshooting')))
const TestMyVideo = withSuspense(lazy(_=>import('views/supp/TestMyVideo')))
const AdminMixAndMatch = withSuspense(lazy(_=>import('views/admin/prods/mix-and-match/MixAndMatch')))
const ClinicProfile = withSuspense(lazy(_=>import('views/clinic_profile/ClinicProfile')))
const ClinicProfileEditor = withSuspense(lazy(_=>import('views/clinic_profile/ClinicProfileEditor')))

const MedCert = withSuspense(lazy(_=>import('views/public/medcert')))
const PathReq = withSuspense(lazy(_=>import('views/public/pathreq')))
const DocLet = withSuspense(lazy(_=>import('views/public/letter')))
const DecRef = withSuspense(lazy(_=>import('views/public/refer')))
const ViewDocument = withSuspense(lazy(_=>import('views/pages/ViewDocument')))

const WaitTime = withSuspense(lazy(_=>import('views/public/waittime/waittime')))

const QRGen = withSuspense(lazy(_=>import('views/admin/qrgen/qrgen')))
const StatOverview = withSuspense(lazy(_=>import('views/admin/stat/overview')))
const StatWaitingRoom = withSuspense(lazy(_=>import('views/admin/stat/waiting_room')))

const ApprAlgo = withSuspense(lazy(_=>import('views/admin/diagram/approval_algo')))

const Privacy = withSuspense(lazy(_=>import('views/content/Privacy')))
const FullTerms = withSuspense(lazy(_=>import('views/content/FullTerms')))
const TreatmentPlanTermsOfService = withSuspense(lazy(_=>import('views/content/TreatmentPlanTermsOfService')))
const ReferralTermsAndConditions = withSuspense(lazy(_=>import('views/content/ReferralTermsAndConditions')))

const AdminProdsNavig = withSuspense(lazy(_=>import('xAppLib/ProdsNavig/AdminProdsNavig')))
const CancelFollowUpPresc = withSuspense(lazy(_=>import('views/prescs/CancelFollowUpPresc')))

const Reminders = withSuspense(lazy(() => import('views/reminders')))
const Reminder = withSuspense(lazy(() => import('views/reminders/Reminder')))
const AddReminder = withSuspense(lazy(() => import('views/reminders/AddReminder')))
const MedNotification = withSuspense(lazy(() => import('views/reminders/ReminderNotificationController')))
const AdminNotificationsList = withSuspense(lazy(() => import('views/reminders/AdminNotificationsList')))

const ContentfulPage = React.lazy(() => import('./contentful/ContentfulPage'))


import CMSPage from 'views/cms/CMSPage'
import Alert from "./views/NUI/Alert";
const AuditList = withSuspense(lazy(_=>import('cosmetics/audit/views/AuditList')))
const AuditPage = withSuspense(lazy(_=>import('cosmetics/audit/views/Audit')))
const InventoryList = withSuspense(lazy(_ => import("./views/inventory/InventoryList")))
const InventoryStats = withSuspense(lazy(_ => import("./views/inventory/Stats")))
const DrugBook = withSuspense(lazy(_ => import("./views/inventory/DrugBook")))
import ISCustomerTermsAndConditions from "./views/content/ISCustomerTermsAndConditions";
import ISPlatformTermsAndConditions from "./views/content/ISPlatformTermsAndConditions";
import CodeOfPractice from "./views/content/CodeOfPractice";
const  ModernPharmacyLocations = withSuspense(lazy(_ => import("./views/modern_pharmacy/ModernPharmacyLocations")))
const ModernPharmacyPrivacyPolicy = withSuspense(lazy(_ => import("./views/modern_pharmacy/ModernPharmacyPrivacy")))

const AutomaticallyGeneratedNotesPage = withSuspense(lazy(_ => import('./views/doc/doccons/AutomaticallyGeneratedNotesPage')))

const MedicationOptionsFromScript = withSuspense(lazy(_=>import('views/ecommerce/MedicationSelectorFromScript')))
const ShoppingBag = withSuspense(lazy(_=>import('views/ecommerce/ShoppingBag')))
const OrderCheckout = withSuspense(lazy(_=>import('views/ecommerce/OrderCheckout')))
const OrderPagePts = withSuspense(lazy(_=>import('views/ecommerce/OrderPage')))
const ListOrders = withSuspense(lazy(_=>import('views/ecommerce/staff/ListOrders')))

const Medications = withSuspense(lazy(() => import('views/pages/Medications')))
const TestResults = withSuspense(lazy(() => import('views/pages/TestResults')))
const Referrals = withSuspense(lazy(() => import('views/pages/Referrals')))
const Certificates = withSuspense(lazy(() => import('views/pages/Certificates')))
const ProgramsPage = withSuspense(lazy(() => import('views/pages/Programs')))
const Sitemap = withSuspense(lazy(() => import('views/sitemap/Sitemap')))

// IS2.0
const OrderFlow = withSuspense(lazy(_ => import("./views/ordering/OrderFlow")))
const ConsultsLandingPage = withSuspense(lazy(_ => import("./views/ordering/Consults/ConsultsLandingPage")))
const MedCertLandingPage = withSuspense(lazy(_ => import("./views/ordering/MedCert/MedCertLandingPage")))
const SpecialistReferralLandingPage = withSuspense(lazy(_ => import("./views/ordering/SpecialistReferral/SpecialistReferralLandingPage")))
const PathologyLandingPage = withSuspense(lazy(_ => import("./views/ordering/Pathology/PathologyLandingPage")))
const OrderProgress = withSuspense(lazy(_ => import("./views/ordering/OrderProgress")))
const WeightLossFlowSelection = withSuspense(lazy(_ => import("./views/ordering/Consults/WeightLossFlowSelection")));
import TreatmentPageWrapper from "./contentful/pages/treatment/TreatmentPageWrapper"
import TreatmentMenu from "./contentful/pages/treatment/TreatmentMenu"
import LandingPageWrapper from "./contentful/pages/landing_pages/LandingPageWrapper"
import WeightLossLandingPage from "./contentful/pages/landing_pages/WeightLossLandingPage";
import { prescUpdate } from "./xAppLib/AHPRA/LearnMore";
import PulseRewards from "./views/pages/PulseRewards";
import { medCertModals } from "./views/content/MedCertModal";
const PrescriptionCheckout = withSuspense(lazy(_ => import("./views/ecommerce/PrescriptionCheckout")))
const CareersPage = withSuspense(lazy(_ => import("./contentful/pages/careers/CareersPageWrapper")))
const DoctorInvoices = withSuspense(lazy(_ => import("./views/doc/accounts/invoices/DoctorInvoices")))
const SentryRoutes = withSentryReactRouterV6Routing(Routes)

const DEBUG = false

const AppGuard = ({ target, access, component,  no_data_preload = false, children, redirectAfterLogin = false, ...restOfProps }) => {
	const params = useParams()

	if (target && !(target.includes(app.runtime.app) || target.includes(app.runtime.mode))) return null;

	if (!no_data_preload && !app.state.loaded) return <Loader active />;

	if (access) {
		DEBUG && console.log('checking access', (typeof access == 'string' && access) || 'function');
		const r = (() => {
			if (redirectAfterLogin) {
				// The previous logic was faulty when `access` was a function that tried to set the `goto_after_login`,
				// in that it would fall back to calling `limit_access(access)` if the user check fails, which would
				// clear the `goto_after_login` and the redirect on login wouldn't work! I don't feel comfortable
				// changing the existing logic, so hiding this behind a new prop that also makes redirecting after
				// login more straight forward
				return (
					typeof access == "function"
						? access({ params })
						: user_model.limit_access(access, null, true, app.history.location.pathname + app.history.location.search)
				);
			} else {
				return (typeof access == "function" && access({ params })) || user_model.limit_access(access);
			}
		})();

		DEBUG && console.log('access=>', r);

		if (!r) return null;
	}
	const combined = { match: {  params }, ...restOfProps }

	return children ? React.cloneElement(children, combined) : component ? React.createElement(component, combined) : null
};


export const ProfileRoute = () => <SentryRoutes><Route path="/profile" element={<AppGuard access><UserProfile size='large'/></AppGuard>} /></SentryRoutes>;

const PathoCRedir = () => <Navigate to={`/c/pharm/patho/${useParams()?.patho_id||''}`} replace />
const PathoMRedir = () => <Navigate to={`/m/pharm/patho/${useParams()?.patho_id||''}`} replace />

const PathoNewResultsRedirect = () => <Navigate to={`/results_followup_all`} replace />

// I'm not sure when these would ever return no access, but perhaps if there are some patho that are only
// available after a consult with a doctor?
const wrapPage = (Component, cat_nm, access) => (
	withData(
		withCatRoute(
			withAccess(Component, access),
		),
		_ => cat_model.get_cat_list({cat_nm}),
	)
);

// const getMappedSlug = (slug) => {
// 	const specificConditionRoute = SPECIFIC_CONDITION_REDIRECTS[slug]
// 	if(specificConditionRoute){
// 		return `/${specificConditionRoute}`
// 	}
// 	const newSlug = CONDITIONS_PAGES_MAPPING[slug]
// 	if(newSlug) {
// 		return `/treatment/${newSlug}`
// 	}
// 	return `/c/pharm/${slug}`
// }

const PharmOrderFlow = wrapPage(OrderFlow, "pharm", Med.access);

const NEW_ORDERING_ROUTES = [
	// These will mask the old landing page/med form if the relevant experiment is active (ex5232:landing, ex5232:flow)
	{
		cat_nm: "pharm",
		cat_route: "certs",
		pages: {
			landing: MedCertLandingPage,
			order: OrderFlow,
		},
	},
	{
		cat_nm: "pharm",
		cat_route: "express-specialist-referrals",
		pages: {
			landing: SpecialistReferralLandingPage,
			order: OrderFlow,
		},
	},
	{
		cat_nm: "pharm",
		cat_route: "patho",
		pages: {
			landing: PathologyLandingPage,
			order: OrderFlow,
		},
	},
	{
		cat_nm: "pharm",
		cat_route: "DocCons",
		pages: {
			landing: ConsultsLandingPage,
			order: OrderFlow,
		},
	},
	{
		cat_nm: "pharm",
		cat_route: "online",
		pages: {
			// landing: ConsultsLandingPage,
			order: OrderFlow,
		},
	},
	{
		cat_nm: "pharm",
		cat_route: "online/prescription",
		pages: {
			// landing: ConsultsLandingPage,
			order: OrderFlow,
		},
	},
	{
		cat_nm: "pharm",
		cat_route: "SubCons",
		pages: {
			order: OrderFlow,
		},
	},
].map(config => ({
	...config,
	pages: {
		landing: wrapPage(config.pages.landing, config.cat_nm, CatExp.access),
		order: wrapPage(config.pages.order, config.cat_nm, Med.access),
	}
}));

const BLSTempDisabled = () => <Container>
	<Alert className={"mt-8 text-center"} info>
	<p>We have temporarily paused our consultations.</p>
	<p>We will return to full operation soon.</p>
	</Alert>
</Container>



// Plain Contentful landing pages, only used when the server's page list is missing or can't be read
const KNOWN_LANDING_PAGES = [
	'about-us',
	'code-of-practice',
	'doctors-note',
	'gp-online',
	'online-doctor',
	'online-medical-certificates',
	'online-medical-certificates/daycare',
	'online-medical-certificates/carers-leave',
	'online-pathology-requests',
	'online-scripts',
	'online-specialist-referrals',
	'test/blood-test',
	'test/cholesterol-blood-test',
	'test/covid-pcr-test',
	'test/erectile-dysfunction-test',
	'test/fertility-blood-tests',
	'test/fertility-test',
	'test/food-intolerance-test',
	'test/irritable-bowel-tests',
	'test/menopause-blood-test',
	'test/pcos-blood-test',
	'test/pregnancy-blood-test',
	'test/vegan-blood-tests',
	'womens-health',
]
// Contentful landing pages injected by SSR as JSON, so removing a page from Contentful removes its route. Skips pages that stay
// hardcoded (extra props or component, or a Firestore slug that isn't the Contentful slug: treatment/) and router syntax (":", "*").
const LANDING_SLUG = /^(?!homepage$|faq$|doctor-careers$|treatment\/)[\w-]+(\/[\w-]+)*$/
const MED_CERT_SLUG = /^online-medical-certificates(?:\/|$)/
const dynamicLandingPageRoutes = (() => {
	let slugs = KNOWN_LANDING_PAGES
	try {
		const tag = document.getElementById('__pages__')
		if (tag) {
			slugs = JSON.parse(tag.text).filter(slug => LANDING_SLUG.test(slug))
		}
	} catch (e) {
		console.error(e)
	}
	return slugs
		.map(slug =>
			<Route
				key={slug}
				path={'/' + slug}
				element={
					<LandingPageWrapper
						// test pages: the URL and Firestore slug have the `test/` prefix but the Contentful slug doesn't
						slug={slug.replace(/^test\//, '')}
						// online-medical-certificates and its sub pages need the med cert modals
						parsedFunctions={MED_CERT_SLUG.test(slug) ? medCertModals : undefined}
					/>
				}
			/>
		)
})()

export default function AppRoutes() {
		const popups = app.app_data.ws_conf.popups
		const host = location.host
		
		const is_pharm = host == "pharmapp.instantscripts.com.au" && ( app.state.loaded && app.dvc.org.type=='pharm')
		const is_cosm = ['cosmapp.instantscripts.com.au', 'instantcosmetics.com.au','icosm.com.au','d.icosm.com.au'].includes(host) && (app.dvc.org.type=='cosm' && user_model.check_access('nurse'))

		const target = app.runtime.mode == 'cmg' && 'cmg' || app.runtime.mode == 'cbls' && 'cbls' || app.runtime.app

		return (
				<SentryRoutes>
					
						<Route path="/auth" element={ <Authenticate /> }  />
						{/* Outside the `target === 'iscr'` block: the QR is scanned by a phone camera, which opens a
						    plain browser with no runtime hints, so this has to resolve unconditionally. */}
						<Route path="/im-in-a-booth" element={ <ImInABooth /> }  />
						<Route path="/im-in-a-booth/confirm" element={ <PostBoothOrder /> }  />
						<Route path="/c/patho" element={ <PathoCRedir /> }  />
						<Route path="/c/patho/:patho_id" element={ <PathoCRedir /> }  />
						<Route path="/m/patho" element={ <PathoMRedir /> }  />
						<Route path="/m/patho/:patho_id" element={ <PathoMRedir /> }  />

					{target === 'iscr' && <>
						    {/* ISCR INDEXED URLS */}
							<Route path="/" element={<HomepageWrapper />} />
							<Route path="/index.html" element={<HomepageWrapper />} />
							<Route path="/navig" element={<ProdsNavig />} />
							<Route path="/onepass" element={<OnePass />} />
							<Route path="/pulse-rewards" element={<PulseRewards />} />
							<Route path="/refer-a-friend" element={<Refer />} />
							<Route path='/pricing' element={<Pricing />} />
							<Route path='/privacy' element={<Container><Privacy /></Container>} />
							<Route path='/treatment-plan-terms' element={<Container><TreatmentPlanTermsOfService /></Container>} />
							<Route path='/refer-a-friend-terms' element={<Container><ReferralTermsAndConditions /></Container>} />
							<Route path='/terms-conditions' element={<Container><FullTerms  target={target}/></Container>} />
							{!is_pharm && !is_cosm  && <Route path='/about' element={<About />} />}
							<Route path="/pharmacy-health-hub" element={<AppGuard><ModernPharmacyLocations /></AppGuard>} />
							<Route path="/phh/privacy" element={<AppGuard><ModernPharmacyPrivacyPolicy /></AppGuard>} />
							{/* ISCR INDEXED URLS */}

							<Route path="/med/*" element={
								<SiteToggle path="ordering/flow" withProps>
									<SiteToggle.Variant variant="is" defaultVariant={!app.settings.iscr2}>
										<MedsWdata_arr.pharm />
									</SiteToggle.Variant>
										<SiteToggle.Variant variant="is2" defaultVariant={app.settings.iscr2}>
											<PharmOrderFlow cat_nm="pharm" unsplat fallback={MedsWdata_arr.pharm}/>
										</SiteToggle.Variant>
								</SiteToggle>
							}/>
							<Route path="/remed/*" element={
								<SiteToggle path="ordering/flow" withProps>
									<SiteToggle.Variant variant="is" defaultVariant={!app.settings.iscr2}>
										<MedsWdata_arr.pharm />
									</SiteToggle.Variant>
										<SiteToggle.Variant variant="is2" defaultVariant={app.settings.iscr2}>
											<PharmOrderFlow cat_nm="pharm" req_type="remed" fallback={MedsWdata_arr.pharm}/>
										</SiteToggle.Variant>
								</SiteToggle>
							}/>
							{NEW_ORDERING_ROUTES.map(({cat_nm, cat_route, pages}) => (
								<React.Fragment key={`${cat_nm}-${cat_route}`}>
									<Route path={`${app.consts.routes.cat_route}/${cat_nm}/${cat_route}`}
										   element={(
											   <AppGuard>
												   <SiteToggle path="ordering/landing" withProps>
													   <SiteToggle.Variant variant="is" defaultVariant={!app.settings.iscr2}>
														   <CatsWdata_arr.pharm {...{cat_nm, cat_route}}/>
													   </SiteToggle.Variant>
													   {pages.landing && (
														   <SiteToggle.Variant variant="is2" defaultVariant={app.settings.iscr2}>
															   <pages.landing {...{cat_nm, cat_route}}/>
														   </SiteToggle.Variant>
													   )}
												   </SiteToggle>
											   </AppGuard>
										   )}/>
									<Route path={`cat/${cat_route}`}
										   element={(
											   <AppGuard>
												   <SiteToggle path="ordering/landing" withProps>
													   <SiteToggle.Variant variant="is" defaultVariant={!app.settings.iscr2}>
														   <CatsWdata_arr.pharm {...{cat_nm, cat_route}}/>
													   </SiteToggle.Variant>
													   {pages.landing && (
														   <SiteToggle.Variant variant="is2" defaultVariant={app.settings.iscr2}>
															   <pages.landing {...{cat_nm, cat_route}}/>
														   </SiteToggle.Variant>
													   )}
												   </SiteToggle>
											   </AppGuard>
										   )}/>
									<Route path={`${app.consts.routes.med_route}/${cat_nm}/${cat_route}/:med_code`}
										   element={(
											   <AppGuard>
												   <SiteToggle path="ordering/flow" withProps>
													   <SiteToggle.Variant variant="is" defaultVariant={!app.settings.iscr2}>
														   <MedsWdata_arr.pharm {...{cat_nm, cat_route}}/>
													   </SiteToggle.Variant>
													   {pages.order && (
														   <SiteToggle.Variant variant="is2" defaultVariant={app.settings.iscr2}>
															   <pages.order {...{cat_nm, cat_route}}
																			fallback={MedsWdata_arr.pharm}/>
														   </SiteToggle.Variant>
													   )}
												   </SiteToggle>
											   </AppGuard>
										   )}/>
								</React.Fragment>
							))}

							<Route path={`/order/:sid`} element={(
								<AppGuard redirectAfterLogin access="user">
									<OrderProgress />
								</AppGuard>
							)} />
						</>}

						{Object.keys(popups).filter(k=>popups[k].target.includes(target))
						.map(k=> <Route key={k} path={`/${popups[k].u||popups[k].pn}`} element={
							<AppGuard no_data_preload target={popups[k].target}>
								{ target == 'cbls' && <BlsHomePage popup={popups[k]} />
								|| target == 'cmg' && <MgHomePage popup={popups[k]} />
								|| <HomepageWrapper popup={popups[k]} />}
							</AppGuard>} />
						)}

						{target == 'icosm' && <>
							<Route exact path="/" element={app.dvc.org?.type=='cosm' && user_model.check_access('nurse') && <IcosmLoggedInHome/> || <ICosmHomepage/>} />
							{/*<Route exact path="/instantcosmetics-team" element={<ICosmTeam/>} />*/}
							{ /* <Route exact path="/qld-cosmetic-nurses-urgent-update" element={<ICosmQld/>} /> */} 
							<Route exact path="/nurse" element={<ICosmNurse/>} />
							<Route exact path="/grow" element={<ICosmGrow/>} />
							<Route exact path="/our-values" element={<ICosmValues/>} />
							<Route exact path="/oversight" element={<ICosmNurse/>} />
							<Route exact path="/effective-software" element={<ICosmSoftware/>} />
							<Route exact path="/complicance" element={<ICosmComplicance/>} />
							<Route exact path="/medical-oversight" element={<ICosmOversight/>} />
							<Route exact path="/training-events" element={<ICosmTraining/>} />
							<Route exact path="/support" element={<ICosmSupport/>} />
							<Route exact path="/contact" element={<ICosmContact/>} />
							<Route exact path="/instantcosmetics-faqs" element={<ICosmFaq/>} />
							<Route exact path="/join" element={<ICosmJoin/>} />
							<Route exact path="/clinical-advisory-committee" element={<ICosmClinicalAdvisoryCommittee />} />
							<Route exact path='/privacy' element={<Container><Privacy /></Container>} />

							<Route path="/training" group='cosm_train' element={<ProdsSale group='cosm_train' />} />
							
							<Route path="/capture-complication" exact element={<AppGuard><Complications /></AppGuard>} />
							<Route exact path="/org/my-clinic-profile" element={<AppGuard access={"mang"}><ClinicProfileEditor /></AppGuard>} />
							<Route path="/treatments/create" element={<AppGuard><CreateTreatmentForm /></AppGuard>} />
							<Route path="/treatments" element={<AppGuard><ListTreatmentPlans view="nurse" /></AppGuard>} />
							<Route path="/treatment/:sid/redo" element={<AppGuard><CreateTreatmentForm /></AppGuard>} />
							<Route path="/treatment/:sid/order" element={<AppGuard><OrderProductForm /></AppGuard>} />
							<Route path="/treatment/:sid/administer" element={<AppGuard><AdministerScheduledProductOrderForm /></AppGuard>} />
							<Route path="/treatment/:sid/:type/product-order" element={<AppGuard><RevisitProductOrderForm /></AppGuard>} />
							<Route path="/treatment/:sid/:type" element={<AppGuard><RevisitTreatmentFormLoader /></AppGuard>} />
							<Route path="/treatment/:sid?" element={<AppGuard><ViewTreatmentPlan /></AppGuard>} />
							
											
						</>}

						
						{target == 'iprep' && <>
							<Route  path="/" element={<IPrepHomepage />} />
							<Route  path="/prep/:what/*" element={<IPrepContent />} />
							<Route  path="/application-progress" element={<AppGuard><IPrepProgress /></AppGuard>} />
						</>}

					   {target == 'cbls' && <>
							<Route path='/' element={<BlsHomePage/>} />
							<Route path='/aboutus' element={<BlsAboutUs/>} />
							<Route path='/getstarted' element={<BlsGetStarted/>} />
							<Route path='/forpatients' element={<BlsForPatients/>} />
							<Route path='/support' element={<BlsSupport/>} />
							{/* <Route path='/med/DocConsICann-cbls' element={<BLSTempDisabled/>}/>
							<Route path='/med/DocConsICannFU-cbls' element={<BLSTempDisabled/>}/> */}
							{/*<Route path='/faq' element={<BlsFaq/>} />*/}
						</> }

						{target == 'cmg' && <>
							<Route path='/' element={<MgHomePage/>} />
							<Route path='/aboutus' element={<MgAboutUs/>} />
							<Route path='/getstarted' element={<MgGetStarted/>} />
							<Route path='/forpatients' element={<MgForPatients/>} />
							<Route path='/support' element={<MgSupport/>} />
							<Route path='/faqs' element={<MgFaq/>} />
							<Route path='/indications' element={<MgIndications/>} />
						</> }


						{target == 'icann' && <>
							<Route  path='/' element={<ICannHomepage />} />
							<Route  path='/getstarted' element={<ICannGetStarted />} />
							<Route  path='/forpatients' element={<ICannPatient />} />
							<Route  path='/support' element={<ICannSupport />} />
							<Route  path='/aboutus' element={<ICannAboutUs />} />
							<Route  path='/faqs' element={<ICannFaq />} />

						</>}

						{/* {target == 'ileg' && <>
							<Route  path="/" element={<ILegHomepage />} />
							<Route  path="/forpatients" element={<ILegPatient />} />
							<Route  path="/forlawyers" element={<ILegLawyer />} />
							<Route  path="/request-demo" element={<ILegRequest />} />
						</>} */}
						
						{app.runtime.theme == 'iscr2' && <Route path="/signup" element={<SignUpPage />} />}

						<Route path="/view-document" element={<AppGuard access="user" redirectAfterLogin><ViewDocument /></AppGuard>} />

						{app.runtime?.login_type=='popup'
						? (
							<Route path="/login" element={app.runtime.mode=='iscr' && <HomepageWrapper />
															|| app.runtime.mode=='icosm' && <ICosmHomepage />
															|| app.runtime.mode=='iprep' && <IPrepHomepage />
															|| app.runtime.mode=='cbls' && <BlsHomePage />
															|| app.runtime.mode=='cmg' && <MgHomePage />
															|| app.runtime.mode=='icann' && <ICannHomepage />
															|| <HomepageWrapper /> }>
								<Route path=":show" element={null} />
							</Route>
							)
						:	(
							app.runtime.theme == 'iscr2' && <Route path="/login" element={<LoginPage />} />
							|| <Route path="/login" element={<Login routed />}>
								<Route path=":show" element={null} />
							</Route>
							)
						}

						<Route path="/r_p/:sid/:enc" element={<Login show={'r_p'} />} />

						<Route path="/profile" element={<AppGuard access><UserProfile size='large'/></AppGuard>}	/>

						<Route path="/profile-password" element={<AppGuard access><Password /></AppGuard>}  />

						<Route path="/test/notifications" element={<AppGuard access="user"><NotificationsPage /></AppGuard>} />
						<Route path="/admin/notifications" element={<AppGuard access="admin"><AdminNotificationsPage /></AppGuard>} />

						{target == 'iscr' && <Route path="/cat" element={<AppGuard><CatsWdata_arr.pharm /></AppGuard>}>
							<Route path="/cat/:cat_route/*" element={null} />
						</Route>}

						<Route path='/med/*' element={<AppGuard><MedsWdata_arr.pharm /></AppGuard>} />

						<Route path='/remed/*' element={<AppGuard><MedsWdata_arr.pharm req_type='remed' /></AppGuard>} />
						
						{/* <Route path="/cat_cosm/:cat_route/*" element={<AppGuard><CatsWdata_arr.cosm alt_cat='_cosm' /></AppGuard>} />
						<Route path='/med_cosm/:cat_route/:med_code' element={<AppGuard><MedsWdata_arr.cosm alt_cat='_cosm' /></AppGuard>} /> */}

						{/* <Route path="/admin/cat/:cat_route/*" element={<AppGuard access="admin_med" component={withCatRoute(AdminCat)} />}/>
						<Route path="/admin/med/:cat_route" element={<AppGuard access="admin_med" component={withCatRoute(AdminMed)} />}>
							<Route path="/admin/med/:cat_route/:med_code" element={null} />
						</Route> */}

						<Route  path={`${app.consts.routes.cat_route}`} element={<AppGuard component={CatsWdata_arr.pharm}/>}	/>
						{cat_nms.map(cat_nm => (
							<Route path={`${app.consts.routes.cat_route}/${cat_nm}/*`} element={<AppGuard alt_cat={cat_nm} component={ CatsWdata_arr[cat_nm] } />} key={`cat${cat_nm}`}>
								{/* <Route path={`${app.consts.routes.cat_route}/${cat_nm}/:cat_route`} element={null} /> */}
								{/* <Route path={`${app.consts.routes.cat_route}/${cat_nm}/*`} element={null} /> */}
							</Route>
						))}

						{cat_nms.map(cat_nm=><Route path={`${app.consts.routes.med_route}/${cat_nm}/*`}
										element={<AppGuard alt_cat={cat_nm}  component={MedsWdata_arr[cat_nm]} />} key={`med${cat_nm}`}	/>)}

						<Route path={`/admin${app.consts.routes.cat_route}`} element={<AppGuard access="admin_med" component={AdminCat} />}>
							<Route path={`/admin${app.consts.routes.cat_route}/:cat_nm`} element={null} />
							<Route path={`/admin${app.consts.routes.cat_route}/:cat_nm/*`} element={null} />
						</Route>

						<Route path={`/admin/meds/`} element={<AppGuard access="admin_med" component={AdminMeds} />}>
							<Route path={`:cat_nm`} element={null} />

						</Route>

						<Route path={`/admin${app.consts.routes.med_route}`} element={<AppGuard access="admin_med" component={AdminMed} />}>
							<Route path={`/admin${app.consts.routes.med_route}/:cat_nm`} element={null} />
							{/* <Route path={`/admin${app.consts.routes.med_route}/:cat_nm/:cat_route`} element={null} /> */}
							<Route path={`/admin${app.consts.routes.med_route}/:cat_nm/*`} element={null} />
						</Route>


						{/* disabled for now
						<Route path='/whitecoat/med/:med_code' element={<AppGuard><MedsWdata_arr.pharm public allow_set_usr /></AppGuard>}/>

						<Route path='/caia/m/:med_code' element={<AppGuard><MedsWdata_arr.pharm script_type='medcons' req_type='maas' public allow_set_usrpartn_oid='MEDU_3o'/></AppGuard>} />
						*/}
``
						<Route path="/admin/docsroster" element={<AppGuard access="cust_supp"><AdminDocsRoster /></AppGuard>}/>
						<Route path="/admin/skypecosts" element={<AppGuard access="docs_stats"><AdminDocsSkypeCosts /></AppGuard>}/>
						<Route path="/admin/doc_ahpra" element={<AppGuard access="cust_supp"><AdminDocsAhpra /></AppGuard>}/>

						<Route path="/admin/batchexport" element={<AppGuard access="cust_supp"><AdminBatchExport /></AppGuard>} />
						
						<Route path="/exprcons/:sid/:enc/" element={<AppGuard access="GP"><ExprCons /></AppGuard>} />
						<Route path="/doccons/:sid/:enc/" element={<AppGuard access="GP"><DocConsEscript /></AppGuard>}>
							<Route path={`:list`} element={null} />
						</Route>
						<Route path="/results_followup" element={<AppGuard access="GP"><PathoNewResultsRedirect /></AppGuard>} />
						<Route path="/results_followup_all" element={<AppGuard access="GP"><ResultsFollowupAll /></AppGuard>} />

						<Route path="/instcons_wr/exprcons" element={<AppGuard access="doc"><InstCons_WR_exprcons /></AppGuard>} />
						<Route path="/instcons_wr/gp" element={<AppGuard access="doc_gp"><InstCons_WR_gp /></AppGuard>} />
						<Route path="/instcons_wr/gp_stats" element={<AppGuard access="show_wr_stats"><InstCons_WR_gp_stats /></AppGuard>} />
						<Route path="/instcons_wr/:wrnm" element={<AppGuard access="doc"><InstCons_WR /></AppGuard>} />
						<Route path="/instcons_wr/cosm" element={<AppGuard access="can_take_cosm_consults"><InstCons_WR /></AppGuard>} />

						<Route path="/instcons_doc/:sid/:wrkey" element={<AppGuard access="doc"><InstCons_cosm_doc /></AppGuard>} />
						<Route path="/cosmetics/consult/:sid" element={<AppGuard access="doc"><CosmeticTreatmentPlanDoctorConsult /></AppGuard>} />
						<Route path="/cosmetics/treatments" element={<AppGuard access="cust_supp"><ListTreatmentPlans view="admin" /></AppGuard>} />
						<Route path="/cosmetics/preview-patient-forms" element={<AppGuard access="cust_supp"><PreviewPatientForms /></AppGuard>} />
						<Route path="/admin/mix-and-match" element={<AppGuard access="admin"><AdminMixAndMatch /></AppGuard>} />
						<Route path="/doccons_view/:sid/:enc" element={<AppGuard access="user" redirectAfterLogin><DocCons_pts /></AppGuard>} />
						<Route path="/docs/mims-online" element={<AppGuard><MIMS /></AppGuard>} />
						<Route path="/docs/tg" element={<AppGuard><TG /></AppGuard>} />

						<Route path="/docnoti" element={<AppGuard access="doc_noti"><DocNoti /></AppGuard>} />

						<Route path="/online" element={<AppGuard access="admin"><OnlineUsers /></AppGuard>} />
						<Route path="/online_doctors" element={<AppGuard access="admin"><OnlineDoctors /></AppGuard>} />

						<Route exact path="/treatmentPlans" element={<AppGuard access={()=>user_model.limit_access('user',null,true, app.history.location.pathname)} ><MyTreatmentPlans/></AppGuard>} />
						<Route exact path="/treatmentPlan/:tpid" element={<AppGuard redirectAfterLogin access={()=>user_model.limit_access('user',null,true, app.history.location.pathname)} ><ManageTreatmentPlan/></AppGuard>} />
						<Route path="/admin/treatmentPlans" element={<AppGuard access="adm_treatment_plan" ><AdminListTreatmentPlans/></AppGuard>} />
						<Route path="/admin/cosmetics/treatment-limits-smoke-test" element={<AppGuard access="cust_supp" ><TreatmentLimitSmokeTest/></AppGuard>} />

						<Route path="/chat" element={<AppGuard access><ChatHome /></AppGuard>}/>

						<Route path="/chat/:channel" element={<AppGuard access><ChatChannel /></AppGuard>}/>

						<Route path='/noaccess' element={<AppGuard><Container><h1 align='center'>No Access</h1></Container></AppGuard>}  />

						<Route path="/admin/orgs" element={<AppGuard access="cust_supp"><AdminOrgs /></AppGuard>}>
							<Route path="/admin/orgs/:oid" element={null} />
						</Route>
						{/* <Route path="/admin/org/:grp_route/:itm_code" element={<AppGuard access="cust_supp"><AdminOrg /></AppGuard>}/> */}

						<Route path="/admin/prods" element={<AppGuard access="admin"><AdminProds /></AppGuard>}>
							<Route path="/admin/prods/:pid" element={null} />
						</Route>
						<Route path="/admin/prod/:pid" element={<AppGuard access="admin"><AdminProd /></AppGuard>}/>

						<Route path="/admin/docs" element={<AppGuard access="admin"><AdminDocs /></AppGuard>}>
							<Route path="/admin/docs/*" element={null} />
						</Route>
						<Route path="/admin/doc/*" element={<AppGuard access="admin"><AdminDoc /></AppGuard>}/>
						<Route path='/admin/docpay/dashboard' element={<AppGuard access='view_docpay'><AdminDocPayDashboardPage /></AppGuard>}>
							<Route path='/admin/docpay/dashboard/*' element={null} />
						</Route>
						<Route path='/admin/docpay/products' element={<AppGuard access='view_docpay'><AdminDocPayProducts /></AppGuard>} />
						<Route path='/admin/docpay/rules' element={<AppGuard access='view_docpay'><AdminDocPayRules /></AppGuard>} />
						<Route path="/admin/site_status" element={<AppGuard access="admin"><AdminSiteStatus /></AppGuard>}/>
						<Route path="/admin/devices" element={<AppGuard access="admin_devices"><AdminDevices /></AppGuard>} />

						<Route path="/admin/stats/:stats_type" element={<AppGuard access="use_stats"><MainStats /></AppGuard>} />

						<Route path="/medicare/stats" element={<AppGuard access="consult_stats"><MedicareStats /></AppGuard>} />
						<Route path="/medicare/list" element={<AppGuard><MedicareList access="root"/></AppGuard>} />

						<Route path="/admin/users/*" element={<AppGuard access={() => user_model.check_access("user_admin") || user_model.check_access("manage_tenant_users", "user:list")}><AdminUsers /></AppGuard>} />
						<Route path="/admin/users_auth"	element={<AppGuard access={() => user_model.check_access("user_admin") || user_model.check_access("manage_tenant_users", "idp-user:list")}><AdminIdpUsers /></AppGuard>} />

						<Route path="/scripts/list" element={<AppGuard access="view_scripts"><ScriptsList /></AppGuard>}>
							<Route path="/scripts/list/:show_list" element={null} />
						</Route>
						<Route path="/script/:sid" element={<AppGuard><ViewScript /></AppGuard>} />
						<Route path="/reqScriptAppr/:sid/:appr" element={<AppGuard access="script_appr"><ViewScript /></AppGuard>}/>

						<Route access="admin" path="/seshs/list" element={<AppGuard><SeshsList /></AppGuard>}>
							<Route access="admin" path="/seshs/list/:show_list" element={null} />
						</Route>

						<Route path="/patients" element={<AppGuard access="pts_srch"><Patients /></AppGuard>}>
							<Route path="/patients/:show_list" element={null} />
						</Route>

						<Route path="/patient/dp/:data_hash" element={<AppGuard access="pts_view"><Patient /></AppGuard>} />
						<Route path="/patient/ui/:by_id/:by_ihi/:by_uid" element={<AppGuard access="pts_view"><Patient /></AppGuard>} />
						<Route path="/patient/cancel_followup_presc" element={<CancelFollowUpPresc/>} />

						<Route path="/admin/prescs/:show_list?" element={<AppGuard access="prescs"><Prescs /></AppGuard>} />
						<Route path="/admin/unactioned_followups" element={<AppGuard access="cust_supp"><Prescs unactioned_followups={true}/></AppGuard>} />
						<Route path="/admin/unactioned_followups_letter" element={<AppGuard access="followup_letter"><Prescs unactioned_followups_letter={true}/></AppGuard>} />

						<Route path="/admin/notes" element={<AppGuard access="admin"><Notes /></AppGuard>} />
						<Route path="/admin/cron" element={<AppGuard access="admin"><Cron /></AppGuard>} />
						<Route path="/admin/mims/user-management" element={<AppGuard access="cust_supp"><MimsUserManagement /></AppGuard>} />
						<Route path="/admin/mims/prescribing-rules" element={<AppGuard access="mims:prescribing-rules:list"><MimsPrescribingRules /></AppGuard>} />
						<Route path="/admin/pricing-shadow" element={<AppGuard access="admin:pricing-shadow:list"><PricingShadowAdmin /></AppGuard>} />
						<Route path="/admin/mims/demo-script-pad" element={<AppGuard access="mims:mws:test-check-interactions"><DemoScriptPad /></AppGuard>} />

						<Route path="/admin/manage_feedback" element={<AppGuard access="manage_feedback"><AdminFeedback /></AppGuard>} />
						<Route path="/admin/manage_feedbacktemplates" element={<AppGuard access="manage_feedback"><AdminFeedbackTemplates /></AppGuard>} />

						<Route path="/admin/carees" element={<AppGuard access="root"><AdminCarees /></AppGuard>} />

						<Route path="/admin/discounts/" element={<AppGuard access="discounts"><Discounts /></AppGuard>} />
						<Route path="/admin/pulse-rewards" element={<AppGuard access="pulse_rewards"><PulseRewardsAdmin /></AppGuard>} />
						<Route path="/admin/pulse-rewards/stats" element={<AppGuard access="pulse_rewards_stats"><PulseRewardsStats /></AppGuard>} />
						<Route path="/admin/priceline-stats" element={<AppGuard access="priceline_stats"><PricelineStats /></AppGuard>} />
						<Route path="/admin/employee-benefits" element={<AppGuard access="employee_benefits"><EmployeeBenefitsAdmin /></AppGuard>} />
						<Route path="/admin/employee-benefits/stats" element={<AppGuard access="employee_benefits_stats"><EmployeeBenefitsStats /></AppGuard>} />
						<Route path="/admin/card-transactions" element={<AppGuard access="admin"><AdminCardTransactions /></AppGuard>} />
						<Route path="/admin/evermed-control-room" element={<AppGuard access="cust_supp"><EvermedControlRoom /></AppGuard>} />
						<Route path="/admin/kb/:type?" element={<AppGuard access="kb_admin"><KBAdmin /></AppGuard>} />
						<Route path="/documents/:type" element={<AppGuard access='user'><KBDirectory /></AppGuard>} />
						<Route path="/cosmtraining" element={<AppGuard><CosmTraining /></AppGuard>} />
						<Route path="/cosmconsumables" element={<AppGuard><CosmProducts /></AppGuard>} />

						<Route path="/scripts/stats" element={<AppGuard access="scripts_stats"><Stats /></AppGuard>} />
						<Route path="/accounts/invoices/:invoice_number?" element={<AppGuard access="scripts_stats"><DoctorInvoices /></AppGuard>} />
						<Route path="/patho/stats/:stats_type" element={<AppGuard><MainStats /></AppGuard>} />

						<Route path="/trans/list" element={<AppGuard access="view_trans"><TransList /></AppGuard>} />
						<Route path="/inventory" element={<AppGuard access={()=>(user_model.check_access('inventory:view') )}><InventoryList /></AppGuard>} />

						<Route path="/inventory/stats" element={<AppGuard access="admin"><InventoryStats /></AppGuard>} />
						<Route path="/drugbook/:pid?/:iid?" element={<AppGuard access={()=>user_model.check_access('drug-book:view')}><DrugBook /></AppGuard>} />


						<Route path="/products/sale" element={<AppGuard access={ProdsSale.access}><ProdsSale /></AppGuard>} />

						
						


						<Route path="/products/shop/*" element={<AppGuard access={Shop.access}><Shop /></AppGuard>} />
						
						<Route path="/products/stats" element={<AppGuard access={Shop.access}><ProdsStats/></AppGuard>} />
						<Route path="/payment" element={<AppGuard><FulfillInvoice /></AppGuard>} />

						<Route path="/products/bpm" element={<AppGuard><ProdsSale group='bpm' /></AppGuard>} />

						<Route path="/org-signup" element={<AppGuard no_data_preload><OrgSignUp /></AppGuard>} />
						<Route path="/doc-signup" element={<AppGuard no_data_preload><DocSignUp /></AppGuard>} />

						<Route path="/manual_script" element={<AppGuard access="admin"><ManualScript /></AppGuard>} />

						<Route path="/admin/data_page/:data_type/:data_loc" element={<AppGuard access="admin"><Data_page /></AppGuard>}>
							<Route path="/admin/data_page/:data_type/:data_loc/:data_par" element={null} />
						</Route>

						<Route path="/pharm/mb_prices" element={<AppGuard><MB_prices /></AppGuard>} >
							<Route path="/pharm/mb_prices/:for_oid" element={null} />
						</Route>

						<Route path="/admin/meds_data_sync" element={<AppGuard access="admin"><GS_DB_sync /></AppGuard>}>
							<Route path="/admin/meds_data_sync/:for_oid" element={null} />
						</Route>

						<Route path="/admin/raw_data" element={<AppGuard access="admin"><EditJsonModal /></AppGuard>} />
						<Route path="/admin/raw_data_cat" loc='/meds_cat/' element={<AppGuard access="raw_data"><EditRawData /></AppGuard>} />

						<Route path='/missedcall/:sid/:mobilehash' element={<AppGuard><DocCons_req /></AppGuard>} />
						<Route path='/docconsreq/:sid/:mobilehash' element={<AppGuard><DocCons_req /></AppGuard>} />
						
						<Route path='/admin/results_raw' element={<AppGuard><Results /></AppGuard>} />
						<Route path='/admin/results/dashboard' element={<AppGuard access="view_scripts"><DashboardResults /></AppGuard>} />
						<Route path='/admin/results/dashboard/requests' element={<AppGuard access="view_scripts"><DashboardResults /></AppGuard>} />
						
						<Route path="/admin/audit_home" element={<AppGuard access="admin"><Audit /></AppGuard>}/>
						<Route path="/admin/audit/scripts" element={<AppGuard access="admin"><AuditScripts /></AppGuard>}/>
						<Route path="/admin/audit/escripts" element={<AppGuard access="admin"><AuditeScripts /></AppGuard>}/>
						<Route path="/admin/audit/dspid" element={<AppGuard access="admin"><AuditeDSPID /></AppGuard>}/>
						<Route path="/admin/audit/orhpan_ihi" element={<AppGuard access="admin"><AuditeOrphanIHI /></AppGuard>}/>
						<Route path="/admin/audit/hi_ihi" element={<AppGuard access="admin"><AuditHIServiceIHI /></AppGuard>}/>
						<Route path="/admin/audit/hi_alert" element={<AppGuard access="admin"><AuditHIOperatorAlerts /></AppGuard>}/>
						<Route path="/admin/audit/hi_err" element={<AppGuard access="admin"><AuditHIServiceError /></AppGuard>}/>
						<Route path="/admin/audit/dup_user" element={<AppGuard access="admin"><DuplicateUsers /></AppGuard>}/>
						<Route path="/admin/audit/hi_batch" element={<AppGuard access="admin"><AuditHIBatch /></AppGuard>}/>

						<Route path='/verify/cert' element={<AppGuard><MedCert /></AppGuard>} />
						<Route path='/verify/cert/:code' element={<AppGuard><MedCert /></AppGuard>} />
						<Route path='/verify/pathreq/:code' element={<AppGuard><PathReq /></AppGuard>} />
						<Route path='/verify/letter/:code' element={<AppGuard><DocLet /></AppGuard>} />
						<Route path='/verify/refer/:code' element={<AppGuard><DecRef /></AppGuard>} />

						<Route path='/waittime' element={<AppGuard><WaitTime /></AppGuard>} />

						<Route path='/qrgen' element={<AppGuard><QRGen /></AppGuard>} />
						<Route path='/stat/overview' element={<AppGuard><StatOverview /></AppGuard>} />
						<Route path='/stat/waiting_room' element={<AppGuard><StatWaitingRoom /></AppGuard>} />
						<Route path='/admin/meds_appr_algo' element={<AppGuard component={ApprAlgo} />} />

						{!["cmg", "cbls"].includes(target) && <>
							<Route exact path="/customer-terms-and-conditions" element={<Container><ISCustomerTermsAndConditions/></Container>} />
							<Route exact path="/platform-terms-and-conditions" element={<Container><ISPlatformTermsAndConditions/></Container>} />
							<Route exact path="/telehealth-code-of-practice" element={<Container><CodeOfPractice/></Container>} />
						</>}
						
						

						<Route path='/test-my-video' element={<AppGuard access="user"><TestMyVideo /></AppGuard>} />
						<Route path='/vidcall-troubleshooting' element={<AppGuard access={() => (app.acl.is_admin || app.acl.is_nurse || app.acl.is_doc)}><VidCallTroubleshooting /></AppGuard>}>
							<Route path='/vidcall-troubleshooting/:oid' element={null} />
						</Route>

						<Route path="/admin/site-routes" element={<AppGuard access="admin"><AdminSiteRoutes /></AppGuard>} />

						<Route path="/feedback/:fbtmpid" element={<Feedback />} />

						<Route path="/booking/availability" element={<AppGuard access="bookable_staff"><BookingAvailability /></AppGuard>} />
						<Route path="/booking/roster" element={<AppGuard access="bookable_staff"><BookingRoster /></AppGuard>} />
						<Route path="/booking/appointments" element={<AppGuard access="bookable_staff"><BookingAppointmentList /></AppGuard>} />

						<Route path="/admin/booking/appointment-preview/:booking_type" element={<AppGuard access="cust_supp"><BookingAppointment /></AppGuard>} />

						<Route path="/admin/booking/availability/:uid" element={<AppGuard access="cust_supp"><AdminBookingAvailability /></AppGuard>} />

						<Route path="/admin/booking/roster" element={<AppGuard access="cust_supp"><AdminBookingTimePeriods /></AppGuard>} />
						<Route path="/admin/booking/roster/:uid" element={<AppGuard access="cust_supp"><AdminBookingRoster /></AppGuard>} />

						<Route path="/admin/booking/roster-users" element={<AppGuard access="cust_supp"><AdminBookingUsers /></AppGuard>} />

						<Route path="/admin/booking/appointments" element={<AppGuard access="cust_supp"><AdminAppointmentList /></AppGuard>} />

						<Route path="/admin/booking/appointment_times/:uid" element={<AppGuard access="cust_supp"><AdminBookingAppointment /></AppGuard>} />
						<Route path="/admin/booking/appointment_times/type/:booking_type" element={<AppGuard access="cust_supp"><AdminBookingAppointment /></AppGuard>} />

						<Route path="/admin/org-booking/users" element={<AppGuard access={() => app.acl.is_mang || app.acl.is_admin || app.acl.is_supp}><OrgAdminRosterUsers /></AppGuard>} />
						<Route path="/admin/org-booking/users/:uid" element={<AppGuard access={() => app.acl.is_mang || app.acl.is_admin || app.acl.is_supp}><OrgAdminRosterUser /></AppGuard>} />
						<Route path="/admin/org-booking/appointments" element={<AppGuard access={() => app.acl.is_mang || app.acl.is_admin || app.acl.is_supp}><OrgAdminAppointmentList /></AppGuard>} />

						<Route path="/org-booking/roster" element={<AppGuard access={() => app.acl.is_nurse}><OrgStaffRoster /></AppGuard>} />
						<Route path="/org-booking/appointments" element={<AppGuard access={() => app.acl.is_nurse}><OrgStaffAppointmentList /></AppGuard>} />

						<Route path="/admin/org-booking/new/:oid" element={<AppGuard access={() => (app.acl.is_mang || app.acl.is_nurse || app.acl.is_admin || app.acl.is_supp)}><OrgStaffBooking /></AppGuard>} />
						<Route path="/admin/org-booking/new/:oid/:ur" element={<AppGuard access={() => (app.acl.is_mang || app.acl.is_nurse || app.acl.is_admin || app.acl.is_supp)}><OrgStaffBooking /></AppGuard>} />


						<Route path="/cosm/audit/list/:type" element={<AppGuard access="audit_user"><AuditList /></AppGuard>} />
						<Route path="/cosm/audit/list" element={<AppGuard access="audit_reviewer"><AuditList /></AppGuard>} />
						<Route path="/cosm/audit/:audit_num" element={<AppGuard access="audit_cosm"><AuditPage /></AppGuard>} />
						<Route path="/twilio/:roomId" element={<AppGuard access={() => (app.acl.is_nurse || app.acl.is_doc || app.acl.is_admin)}><TwiloTestBed /></AppGuard>} />

						<Route path="/test/heidihealth-integration" element={<AppGuard access><AutomaticallyGeneratedNotesPage /></AppGuard>}  />

						<Route path="/prescription-checkout" element={<AppGuard access={'user'}><PrescriptionCheckout /></AppGuard>}  />
			
						{target == 'iscr' && <>	
						{/*PAGES*/}
						<Route exact path="/blood-pressure-monitor" element={<CMSPage target='pages' url="/blood-pressure-monitor"/>} />
						<Route exact path="/childrens-doctor-online" element={<CMSPage target='pages' url="/childrens-doctor-online"/>} />
						<Route exact path="/chlamydia" element={<CMSPage target='pages' url="/chlamydia"/>} />
						<Route exact path="/contact-us" element={<CMSPage target='pages' url="/contact-us"/>} />
						<Route exact path="/doctor-feedback" element={<CMSPage target='pages' url="/doctor-feedback"/>} />
						<Route exact path="/for-pharmacies" element={<CMSPage target='pages' url="/for-pharmacies"/>} />
						<Route exact path="/gonorrhea" element={<CMSPage target='pages' url="/gonorrhea"/>} />
						<Route exact path="/health-check-online" element={<CMSPage target='pages' url="/health-check-online"/>} />
						<Route exact path="/immune-system-test" element={<CMSPage target='pages' url="/immune-system-test"/>} />
						<Route exact path="/medication-delivery" element={<CMSPage target='pages' url="/medication-delivery"/>} />
						<Route exact path="/mens-health" element={<CMSPage target='pages' url="/mens-health"/>} />
						<Route exact path="/mental-health-care-plans" element={<CMSPage target='pages' url="/mental-health-care-plans"/>} />
						<Route exact path="/online-medical-certificates-employers" element={<CMSPage target='pages' url="/online-medical-certificates-employers"/>} />
						<Route exact path="/pharmacy-registration" element={<CMSPage target='pages' url="/pharmacy-registration"/>} />
						<Route exact path="/pregnancy-planning-test" element={<CMSPage target='pages' url="/pregnancy-planning-test"/>} />
						<Route exact path="/syphilis" element={<CMSPage target='pages' url="/syphilis"/>} />
						<Route exact path="/telehealth-consultations" element={<CMSPage target='pages' url="/telehealth-consultations"/>} />
						<Route exact path="/tiredness-test" element={<CMSPage target='pages' url="/tiredness-test"/>} />
						<Route exact path="/treatment-plans" element={<CMSPage target='pages' url="/treatment-plans"/>} />
						<Route exact path="/troubleshooting" element={<CMSPage target='pages' url="/troubleshooting"/>} />
						
						{/* <Route exact path="/covid-antivirals-1" element={<CMSPage target='pages' url="/covid-antivirals-1"/>} />
						<Route exact path="/smoking" element={<CMSPage target='pages' url="/smoking"/>} />
						<Route exact path="/hayfever" element={<CMSPage target='pages' url="/hayfever"/>} />
						<Route exact path="/asthma" element={<CMSPage target='pages' url="/asthma"/>} />
						<Route exact path="/contraception" element={<CMSPage target='pages' url="/contraception"/>} />
						<Route exact path="/blood-pressure" element={<CMSPage target='pages' url="/blood-pressure"/>} />
						<Route exact path="/genital-herpes" element={<CMSPage target='pages' url="/genital-herpes"/>} />
						<Route exact path="/cholesterol" element={<CMSPage target='pages' url="/cholesterol"/>} />
						<Route exact path="/online-uti-treatment" element={<CMSPage target='pages' url="/online-uti-treatment"/>} />
						<Route exact path="/mens-hair-loss" element={<CMSPage target='pages' url="/mens-hair-loss"/>} />
						<Route exact path="/mental-health-services" element={<CMSPage target='pages' url="/mental-health-services"/>} />
						<Route exact path="/pregnancy-test-and-care" element={<CMSPage target='pages' url="/pregnancy-test-and-care"/>} />
						<Route exact path="/womens-health-services" element={<CMSPage target='pages' url="/womens-health-services"/>} />
						<Route exact path="/sti-test-online" element={<CMSPage target='pages' url="/sti-test-online"/>} />
						<Route exact path="/doctor-consultation-jobs" element={<CMSPage target='pages' url="/doctor-consultation-jobs"/>} />
						<Route exact path="/telehealth-b" element={<CMSPage target='pages' url="/telehealth-b"/>} />
						<Route exact path="/media_release" element={<CMSPage target='pages' url="/media_release"/>} /> */}
						{/*PAGES*/}
						

						{/*Temp for testing*/}
						{/* <Route exact path="/new-medical-certificates/" element={<CMSPage target='pages' url="/new-medical-certificates/"/>} /> */}

						<Route exact path="/media_release" element={<CMSPage target='pages' url="/media_release"/>} />
						{/*MEDIA_RELEASE*/}
						<Route exact path="/media_release/instantscripts-donates-10000-to-qld-helicopter-crash-family" element={<CMSPage target='media-release' url="/media_release/instantscripts-donates-10000-to-qld-helicopter-crash-family"/>} />
						<Route exact path="/media_release/instantscripts-to-be-acquired-by-wesfarmers-health" element={<CMSPage target='media-release' url="/media_release/instantscripts-to-be-acquired-by-wesfarmers-health"/>} />
						<Route exact path="/media_release/instantscripts-responds-to-medical-board-of-australias-revised-telehealth-guidelines" element={<CMSPage target='media-release' url="/media_release/instantscripts-responds-to-medical-board-of-australias-revised-telehealth-guidelines"/>} />
						<Route exact path="/media_release/bulk-billed-gp-telehealth-consultations-break-cost-and-access-barriers-to-mental-health-services" element={<CMSPage target='media-release' url="/media_release/bulk-billed-gp-telehealth-consultations-break-cost-and-access-barriers-to-mental-health-services"/>} />
						<Route exact path="/media_release/free-telehealth-services-for-flood-ravaged-town-of-eugowra" element={<CMSPage target='media-release' url="/media_release/free-telehealth-services-for-flood-ravaged-town-of-eugowra"/>} />
						<Route exact path="/media_release/making-mental-health-treatment-plans-more-accessible-via-telehealth" element={<CMSPage target='media-release' url="/media_release/making-mental-health-treatment-plans-more-accessible-via-telehealth"/>} />
						<Route exact path="/media_release/increased-telehealth-usage-could-help-solve-national-gp-shortage" element={<CMSPage target='media-release' url="/media_release/increased-telehealth-usage-could-help-solve-national-gp-shortage"/>} />
						<Route exact path="/media_release/digital-healthcare-model-can-ease-pressure-on-gps" element={<CMSPage target='media-release' url="/media_release/digital-healthcare-model-can-ease-pressure-on-gps"/>} />
						{/*MEDIA_RELEASE*/}


    						
    						{/*CONTENTFUL LANDING PAGES*/}
						<Route exact path="/doctor-careers" element={<CareersPage slug={"doctor-careers"}  />} />
						<Route exact path="/treatment/weight-loss" element={<WeightLossLandingPage slug={"weight-loss"} />} />
						<Route exact path="/treatment/weight-management-selection" element={<WeightLossLandingPage slug={"weight-management-selection"} />} />
						<Route exact path="/treatment/weight-management-booking-selection" element={<WeightLossFlowSelection />} />
						<Route exact path="/faq" element={<LandingPageWrapper slug={"faq"} parsedFunctions={prescUpdate} />}/>
    {/*CONTENTFUL LANDING PAGES*/}
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
						</>}
						
						<Route path='/admin/navig' element={<AppGuard><AdminProdsNavig /></AppGuard>} />

						<Route path='/clinic/:oid' element={<AppGuard><ClinicProfile /></AppGuard>} />

						<Route path='/reminders' element={<AppGuard access="user"><Reminders /></AppGuard>} />
						<Route path='/reminders/add' element={<AppGuard access="user"><AddReminder /></AppGuard>} />
						<Route path='/reminders/:reminder_id/edit' element={<AppGuard access="user"><AddReminder /></AppGuard>} />
						<Route path='/reminders/:reminder_id' element={<AppGuard access="user"><Reminder /></AppGuard>} />
						<Route path='/reminder-notification/:reminder_notification_id' element={<AppGuard access="user"><MedNotification /></AppGuard>} />

						<Route path='/admin/reminders/notifications' element={<AppGuard access="admin"><AdminNotificationsList /></AppGuard>} />
						<Route path='/admin/reminders' element={<AppGuard access="admin"><AdminRemindersList /></AppGuard>} />


						<Route path='/shop/dispense_medication/:sid/:scid' element={<AppGuard access="user"><MedicationOptionsFromScript /></AppGuard>} />
						<Route path='/shop/cart' element={<AppGuard access="user"><ShoppingBag /></AppGuard>} />
						<Route path='/shop/checkout' element={<AppGuard access="user"><OrderCheckout /></AppGuard>} />
						<Route path='/shop/order/:ord_num' element={<AppGuard access="user"><OrderPagePts /></AppGuard>} />

						<Route path={'/admin/orders'} element={<AppGuard access={() => user_model.check_access("user_admin") || user_model.check_access("manage_tenant_users", "ecommerce:retrieve_orders:basic")}><ListOrders /></AppGuard>} />
						<Route path="/medications" element={<AppGuard redirectAfterLogin access="user"><Medications /></AppGuard>} />
						<Route path="/test-results" element={<AppGuard access="user"><TestResults /></AppGuard>} />
						<Route path="/referrals" element={<AppGuard access="user"><Referrals /></AppGuard>} />
						<Route path="/certificates" element={<AppGuard access="user"><Certificates /></AppGuard>} />
						<Route path="/programs" element={<AppGuard access="user"><ProgramsPage /></AppGuard>} />

						<Route path="/history" element={
							<AppGuard access={() => user_model.limit_access('user',null,true, app.history.location.pathname)}>
								{app.settings.iscr2 ? <HistoryWithData/> : <OldHistoryWithData />}
							</AppGuard>}>
							<Route path="/history/:sid" element={null} />
						</Route>
						<Route path='/sitemap' element={<Sitemap />} />
						<Route path='/blog/*' element={<BlogWrapper />} />
					
						<Route path='/treatment' exact element={<TreatmentMenu />} />
						<Route path='/treatment/:page_slug' element={<TreatmentPageWrapper  />} />
						<Route path='/content/:content_type/*' element={<ContentfulPage/>} />
						<Route path='/content-preview/:content_type/*' element={<ContentfulPage preview/>} />
						<Route path='/weight-loss' element={<Navigate to="/treatment/weight-loss" replace />} />
						<Route path='/privacy-policy' element={<Navigate to="/privacy" replace />} />
						{/* Last, so every explicit route (incl. redirects like /weight-loss) wins over a Contentful page with the same path */}
						{target === 'iscr' && dynamicLandingPageRoutes}
						<Route path='*' element={<NotFound />}/>
				</SentryRoutes>
		);

	}

						// <Route access path="/conf1" render={props=><TestConf {...props} user="Mr Chrome"/>} 	/>
						// <Route access path="/conf2"  render={props=><TestConf {...props} user="Ms Firefox"/>} />
						// <Route access path="/conf3"  render={props=><TestConf {...props} user="Brave Guy"/>} />
						// <Route access path="/conf/:user*"  element={<AppGuard>< /></AppGuard>TestConf}  />
						// <Route access="admin"  path="/__admin/users" element={<AppGuard>< /></AppGuard>AdminUsers} />
						// <Route
						// 		path='/hivprevent'
						// 		// access={Med.access}
	 					// 		render={ p => <MedsWdataPharm {...p}
	 					// 					script_type='medbuy'
	 					// 					req_type='hivprevent'
	 					// 					public
	 					// 					// free_consult
	 					// 					medbuy_only
	 					// 					med_allow_excl
	 					// 					med_code='-LkX1uMs9Z8K_flKmk1S'
	 					// 					// med_code='-Lp65oy7wLVBFs0YgkWf'
	 					// 				 /> }  />

						// TOFIX: direct med seems to be broken.
						// <Route access={Med.access} path='/medbuytest'
						// 		render={ p => <Med {...p}
						// 					script_type='medbuy'
						// 					req_type='hivprevent'
						// 					public
						// 					free_consult
						// 					medbuy_only
						// 					med_code='-Luh799IudIPilgFyXwH'
						// 				/> }  />
						// <Route path="/test" element={<AppGuard>< /></AppGuard>Test} />
